
export default {
  name: "faqItemMainPage",
  props: ["faq", "index", "open"],
};
